<template>
  <v-container fluid p-0 m-0>
    <v-layout>
      <v-flex align-center justify-space-around row p-0 m-0>
        <v-btn-toggle
          v-model="selected_language"
          mandatory
          @change="languageChange"
          v-if="globals.languages"
        >
          <span v-for="language in languages" :key="language.id">
            <v-btn
              text
              :class="{ 'hide': !(globals.languages.split(',').includes(language.name) || language.name == 'Polski')}"
            >
              <img
                v-bind:src="$env.imagesPATH.default + language.flag_image"
                v-bind:alt="language.name"
                height="24"
              />
            </v-btn>
          </span>
        </v-btn-toggle>
        <v-btn-toggle
          multiple
          v-model="accessibility"
          @change="changeAccessibility"
          v-if="globals.accessibility"
        >
          <v-btn
            :class="{ 'hide': !globals.accessibility.split(',').includes('Popraw czytelność')}"
          >
            <v-icon v-if="accessibility.includes(0)">{{text_icon.active}}</v-icon>
            <v-icon v-else>{{text_icon.disabled}}</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t("improve_readability")}}</span>
          </v-btn>
          <v-btn :class="{ 'hide': !globals.accessibility.split(',').includes('Wysoki kontrast')}">
            <v-icon v-if="accessibility.includes(1)">{{font_icon.active}}</v-icon>
            <v-icon v-else>{{font_icon.disabled}}</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t("high_contrast") }}</span>
          </v-btn>
        </v-btn-toggle>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "rLanguagePicker",
  props: ["globals"],
  data: () => ({
    languages: [
      { id: 0, name: "Polski", short: "pl", read:"pl_PL", flag_image: "flag_pl.png" },
      {
        id: 1,
        name: "Angielski",
        short: "en",
        read:"en-GB",
        flag_image: "flag_en.png"
      },
      { id: 2, name: "Rosyjski", short: "ru", read:"ru-RU", flag_image: "flag_ru.png" },
      { id: 3, name: "Ukraiński", short: "uk", read:"ru-RU", flag_image: "flag_uk.png" }
    ],
    selected_language: null,
    accessibility: [],
    fontSize: false,
    text_icon: {
      active: "title",
      disabled: "text_fields"
    },
    font_icon: {
      active: "visibility",
      disabled: "visibility_off"
    }
  }),
  created() {
    if (this.$cookie.get("language")) {
      this.selected_language = parseInt(this.$cookie.get("language"));
      this.languageChange(this.selected_language);
    }
    if (this.$cookie.get("accessibility")) {
      this.accessibility = this.$cookie
        .get("accessibility")
        .split(",")
        .map(Number);
      this.changeAccessibility(this.accessibility);
    }
  },
  methods: {
    languageChange: function(event) {
      this.$i18n.locale = this.languages[event].short;
      this.$i18n.read = this.languages[event].read;
      this.$cookie.set("language", event, { expires: "1D" });
    },
    changeAccessibility: function(event) {
      this.$cookie.set("accessibility", event, {
        expires: "1D"
      });

      const html = document.getElementsByTagName("html")[0];

      if (this.globals.accessibility.split(",").includes("Popraw czytelność")) {
        if (event.includes(0)) {
          html.classList.add("uppercase");
        } else {
          html.classList.remove("uppercase");
        }
      } else {
        html.classList.remove("uppercase");
      }

      if (this.globals.accessibility.split(",").includes("Wysoki kontrast")) {
        if (event.includes(1)) {
          this.$store.state.high_contrast = true;
        } else {
          this.$store.state.high_contrast = false;
        }
      } else {
        this.$store.state.high_contrast = false;
      }
    }
  }
};
</script>

<style scoped>
label {
  padding: 0.2em;
}

.hide {
  display: none;
}

[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* IMAGE STYLES */
[type="radio"] + img {
  cursor: pointer;
}

/* CHECKED STYLES */
label[active="true"] {
  border: 1px dotted gray;
  background-color: lightgray;
}
</style>

<style>
.uppercase {
  text-transform: uppercase;
}
</style>